import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidePage from "@/pages/guide/page";
import BeginnersGuidePage from "@/pages/guide/beginners/page";
import SneakerGuidePage from "@/pages/guide/sneakers/page";
import SafetyGuidePage from "@/pages/guide/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/superbuy-spreadsheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/guide/superbuy-spreadsheet-beginners",
    element: <BeginnersGuidePage />,
  },
  {
    path: "/guide/superbuy-spreadsheet-sneakers",
    element: <SneakerGuidePage />,
  },
  {
    path: "/guide/superbuy-spreadsheet-safety",
    element: <SafetyGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;